export default __webpack_public_path__ + "static/media/showroom42.f45c929e.webp";